import { render, staticRenderFns } from "./RbInputFile.vue?vue&type=template&id=72d40d21"
import script from "./RbInputFile.vue?vue&type=script&lang=js"
export * from "./RbInputFile.vue?vue&type=script&lang=js"
import style0 from "./RbInputFile.vue?vue&type=style&index=0&id=72d40d21&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports